import pluginService from 'services/PluginService';
import interactiveService from 'services/InteractiveService';
import activityService from 'services/ActivityService';
import pathwayService from 'services/PathwayService';
import {
  ETEXT_CHAPTER_PLUGIN_ID, 
  ETEXT_COURSE_PLUGIN_ID, 
  STITCHED_LESSON_PLUGIN_ID, 
  CORNUCOPIA_SCREEN_PLUGIN_ID,

  etextCoursePathwayKeyPath, 
  chapterPathwayKeyPath, 
  lessonPathwayKeypath, 

  coursePreload,
  chapterPreload,
  lessonPreload,
  
  courseConfig, 
  chapterConfig, 
  lessonConfig,
  screenConfig,

  pluginVersion,
  pathwayType,
} from '../constants';

/**
 * creates and returns path for Cornucopia Screen Plugin
 * 
 * @param {String} projectId
 * @returns {String} cornucopiaScreenPath
 */

export const createCornucopiaScreen = async (projectId) => {

  // Creating Course
  const courseActivityPlugin = await pluginService.getPlugin(ETEXT_COURSE_PLUGIN_ID, pluginVersion);  
  const courseActivityPluginSchema = JSON.parse(courseActivityPlugin.manifest.configurationSchema);
  const courseActivityId = await activityService.createProjectActivity(
    ETEXT_COURSE_PLUGIN_ID,
    pluginVersion,
    courseActivityPluginSchema,
    courseConfig,
    projectId
  );
  await pathwayService.createPathway(courseActivityId, etextCoursePathwayKeyPath.cover, pathwayType, coursePreload);
  await pathwayService.createPathway(courseActivityId, etextCoursePathwayKeyPath.pages, pathwayType, coursePreload);
  // to create chapters inside a eText course we need Chapters PathwayId
  const courseChapterPathwayId = await pathwayService.createPathway(courseActivityId, etextCoursePathwayKeyPath.chapters, pathwayType, coursePreload);

  
  // Creating chapter inside course
  const chapterPlugin = await pluginService.getPlugin(ETEXT_CHAPTER_PLUGIN_ID, pluginVersion);  
  const chapterPluginSchema = JSON.parse(chapterPlugin.manifest.configurationSchema);
  const chapterActivityId = await activityService.createActivity(
    ETEXT_CHAPTER_PLUGIN_ID,
    pluginVersion,
    chapterPluginSchema,
    chapterConfig,
    false,
    courseChapterPathwayId,
    false,
  );
  const chapterPathwayId = await pathwayService.createPathway(chapterActivityId, chapterPathwayKeyPath, pathwayType, chapterPreload);

  // Creating lesson inside chapters
  const lessonPlugin = await pluginService.getPlugin(STITCHED_LESSON_PLUGIN_ID, pluginVersion);  
  const lessonPluginSchema = JSON.parse(lessonPlugin.manifest.configurationSchema);
  const lessonActivityId = await activityService.createActivity(
    STITCHED_LESSON_PLUGIN_ID,
    pluginVersion,
    lessonPluginSchema,
    lessonConfig,
    false,
    chapterPathwayId,
    false,
  );
  const lessonPathwayId = await pathwayService.createPathway(lessonActivityId, lessonPathwayKeypath, pathwayType, lessonPreload);

  // Creating screen inside lesson
  const { manifest: { configurationSchema } } = await pluginService.getPlugin(CORNUCOPIA_SCREEN_PLUGIN_ID, pluginVersion);
  const screenSchema = JSON.parse(configurationSchema);
  const interactiveId = await interactiveService.createInteractive(
    lessonPathwayId,
    CORNUCOPIA_SCREEN_PLUGIN_ID,
    pluginVersion,
    screenConfig.title,
    screenSchema,
    screenConfig.description,
  );

  const cornucopiaScreenPath = `/cornucopia/lesson/${lessonActivityId}/pathway/${lessonPathwayId}/screen/${interactiveId}`;
  await activityService.saveInActivityConfig(courseActivityId, ['cornucopiaScreenPath'], cornucopiaScreenPath);
  return cornucopiaScreenPath;
};
 
/**
 * returns cornucopia screen path from config for given activity.
 * 
 * @param {String} activityId
 * @returns {String} cornucopiaScreenPath 
 */
export const getCornucopiaScreenPath = async (activityId) => {
  const { config } = await activityService.getActivity(activityId, false, false);
  return config.cornucopiaScreenPath || null;
};